export default __webpack_public_path__ + "static/media/george_constandache.570f06bf.png";